import { ReactNode } from "react"
import { StyledLink } from "./NavigateTo.styled"

interface INavigateToProps {
  to: string
  children: ReactNode
}

export const NavigateTo = ({ to, children }: INavigateToProps) => {
  return <StyledLink to={to}>{children}</StyledLink>
}
